import { render, staticRenderFns } from "./WxWorkFooter.vue?vue&type=template&id=6d33e0e0"
import script from "./WxWorkFooter.vue?vue&type=script&lang=js"
export * from "./WxWorkFooter.vue?vue&type=script&lang=js"
import style0 from "./WxWorkFooter.vue?vue&type=style&index=0&id=6d33e0e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports